<template>
  <div :class="['account', isAdminSection ? 'account--admin' : 'account--customer']">
    <client-only>
      <div class="account__section-wrap">
        <transition name="page">
          <component :is="menuComponent" v-show="hasBeenVisibleOnce && !isReviewingDocument" />
        </transition>
        <div class="account__section">
          <div class="account__section-inner">
            <NuxtChild />
          </div>
        </div>
      </div>
    </client-only>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { waitFor } from '@/helpers/time'
import AccountMenu from '@/components/Account/AccountMenu.vue'
import AdminMenu from '@/components/Admin/AdminMenu.vue'
import { isAdminRouteComputed } from '@/components/Admin/utils'

export default {
  name: 'Account',

  components: {
    AccountMenu,
    AdminMenu,
  },

  data() {
    return {
      hasBeenVisibleOnce: false,
    }
  },

  computed: {
    ...isAdminRouteComputed,

    ...mapState('page', ['isVisible']),

    isReviewingDocument() {
      return this.$route.meta.isReviewingDocument
    },

    menuComponent() {
      return this.isAdminSection ? 'AdminMenu' : 'AccountMenu'
    },
  },

  beforeMount() {
    waitFor(this, () => this.isVisible).then(() => (this.hasBeenVisibleOnce = true))
  },

  mounted() {
    if (this.isAdminSection) this.preloadOverlayWriteMessageForm()
  },

  methods: {
    ...mapActions({
      preloadOverlayWriteMessageForm: 'overlay/preloadOverlayWriteMessageForm',
    }),
  },
}
</script>

<style scoped lang="scss">
@import '@/components/SiteContainer/site-container-settings';
@import '@/components/Account/account-settings';

$_max-width: 900px;
$_menu-max-width: $account-menu-max-width;
$_mq-account-inner-center: $_max-width + $_menu-max-width * 2 + $site-container-h-padding-full * 2;

.account {
  @include floating-site-content-padding;
  display: flex;
  width: 100%;

  @include min-screen($mq-large) {
    justify-content: left;
  }

  &--admin {
    /deep/ .table__cell {
      color: $color-grey-1;

      &--head,
      &--first {
        @include account-cell-head-first;
      }
    }
  }

  &__section-wrap {
    display: flex;
    flex-direction: row;
    flex: 1;
    width: 100%;
  }

  &__section {
    display: flex;
    flex: 1;

    .account--customer & {
      max-width: $_max-width;

      @include min-screen($_mq-account-inner-center) {
        padding-right: $_menu-max-width;
        max-width: none;
      }
    }

    @include max-screen($mq-large) {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }

  &__section-inner {
    width: 100%;

    .account--customer & {
      max-width: $_max-width;

      @include max-screen($mq-large) {
        display: flex;
        flex: 1;
        flex-direction: column;
        width: 100%;
      }

      @include min-screen($mq-larger) {
        margin: 0;
        width: calc(25vw + 380px);
      }

      @include min-screen($mq-full) {
        width: calc(50vw + 100px);
      }

      @include min-screen($_mq-account-inner-center) {
        margin: 0 auto;
        width: $_max-width;
      }
    }
  }
}
</style>
